import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { sharedStyles } from '../../common/css/shared-styles';
import { USBrandCampaign } from '../../common/us-branding';
let USCampaignFooter = class USCampaignFooter extends USBrandCampaign {
    render() {
        return html `
        <footer>
            <div style="margin-bottom: 3rem">
                <p>Questo sito web è destinato a soggetti residenti in Italia.</p>
            </div>
            <div class="footer-band">
                <div class="two-column-footer-grid">
                    <div class="flat-nav">
                        <ul class="flat-list">
                            <li><a @click="${this.trackFooterLink}" href="https://www.franklintempleton.it/chi-siamo/contatti/#digital-accessibility">Accessibilità digitale</a></li>
                            <li><a @click="${this.trackFooterLink}" href="https://www.franklintempleton.it/footer/politica-relativa-alla-sicurezza">Politica relativa alla Sicurezza</a></li>
                            <li><a @click="${this.trackFooterLink}" href="https://www.franklintempleton.it/footer/policy-anticorruzione">Policy in tema di anticorruzione</a></li>
                            <li><a @click="${this.trackFooterLink}" href="https://www.franklintempleton.it/chi-siamo/sustainable-investing-and-stewardship/policies">Politica sulla sostenibilità</a></li>
                            <li><a @click="${this.trackFooterLink}" href="https://www.franklintempletonglobal.com/privacy" target="_blank">Informativa sulla privacy</a></li>
                            <li><a @click="${this.trackFooterLink}" href="https://www.franklintempleton.it/footer/informazioni-legali">Informazioni Legali</a></li>
                            <li><a @click="${this.trackFooterLink}" href="https://www.franklintempletoncareers.com/" target="_blank">Opportunità di Lavoro</a></li>
                        </ul>
                    </div>
                    <div class="social-connections">
                    <ul class="flat-list">
                        <li><strong>Connettiti con noi su:</strong></li>
                        <li><a @click="${this.trackFooterLink}" href="https://www.linkedin.com/company/franklin-templeton/about" data-link-title="LinkedIn"><img src="./assets/images/linkedin-micro.svg" alt="Connect with us on LinkedIn" /></a></li>
                        <li><a @click="${this.trackFooterLink}" href="https://www.youtube.com/playlist?list=PLF6VcuuP6dHjpR6OxDOP0F1AqTTxCnqFI"  data-link-title="YouTube"><img src="./assets/images/youtube-micro.svg" alt="Connect with us on YouTube" /></a></li>
                        <li><a @click="${this.trackFooterLink}" href="https://twitter.com/FTI_Global" data-link-title="X"><img src="./assets/images/social-x-micro.svg" alt="Connect with us on X" /></a></li>
                        <li><a @click="${this.trackFooterLink}" href="https://www.instagram.com/franklintempleton/"  data-link-title="Instagram"><img src="./assets/images/instagram-micro.svg" alt="Connect with us on Instagram" /></a></li>
                    </ul>
                    </div>
                </div>
            </div>
          
        </footer>
        <div class="copyright-band">
                <div class="two-column-copyright-footer">
                    <div class="copyright">
                        <p>Copyright © 2026 Franklin Templeton. Tutti i diritti riservati.</p>
                    </div>
                    <div class="logo">
                        <img src="./assets/images/ft-global-logo-footer.png" alt="Franklin Templeton Investments Logo" />
                    </div>
                </div>
            </div>        
      <slot></slot>`;
    }
};
USCampaignFooter.styles = [
    sharedStyles,
    css `
    :host {
        display: block;
        width: 100%;
        background: transparent;
        padding: 0;
    }

    /*
@media (min-width: 576px) { ... }

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) { ... }

// Large devices (desktops, 992px and up)
@media (min-width: 992px) { ... }

// X-Large devices (large desktops, 1200px and up)
@media (min-width: 1200px) { ... }

// XX-Large devices (larger desktops, 1400px and up)
@media (min-width: 1400px) { ... }
    */

    footer {
        background: #001e62;
        color: #fff;
        padding: 1rem 2rem 0 2rem;
    }
    @media (min-width: 768px) { 
        footer {
            padding: 2rem 2rem 0 2rem;
        }
     }    

    a {
        font-family: var(--base-font-family);
        font-weight: var(--font-weight-regular);
        line-height: var(--fonts-p-line-height);
        text-decoration: none;
        color: var(--white);
    }

    ul {
        margin: 0;
        padding: 0;
        list-style: none;        
    }

    h5, h5 a {
        font-family: var(--font-bold);
        font-size: 1.15rem;
        margin-bottom: .75rem;
    }


    .container {
        display: none;
    }

    @media (min-width: 768px) { 
        .container, .two-column-footer-grid, .two-column-copyright-footer {
            display: grid;
        }
     }     

    .container {  
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: 1fr;
        gap: 0px 0px;
        grid-auto-flow: row;
      }
      
      .col1 {
        justify-self: start;
        align-self: start;
        grid-area: 1 / 1 / 2 / 2;
      }
      
      .col2 { grid-area: 1 / 2 / 2 / 3; }
      .col3 { grid-area: 1 / 3 / 2 / 4; }    
      .col4 { grid-area: 1 / 4 / 2 / 5; }
      .col5 { grid-area: 1 / 5 / 2 / 6; }
          
       {  
        display: grid;
        grid-template-columns: 75% 25%;
        grid-template-rows: 1fr;
        gap: 0px 0px;
        grid-auto-flow: row;
      }

      .copyright-band {
        background: #00081f;
        padding: 1rem;
        color: #fff;        
      }      

      @media (min-width: 768px) { 
        .copyright-band {
            padding: 1rem 2rem 1rem 2rem;
        }
      }

    .two-column-copyright-footer { 
        
        grid-template-columns: 1fr;
        grid-template-rows: 1fr;
        gap: 0px 0px;
        grid-auto-flow: row;        
    }

      .copyright { 
        grid-area: 1 / 1 / 2 / 2; 
      }

      .logo {
        grid-area: 1 / 2 / 2 / 3; 

        & img {
            margin-right: 0;
            margin-left: auto;
            max-width: 200px;
        }
      }

      .flat-nav { 
        grid-area: 1 / 1 / 2 / 2; 
        & ul {
            margin: 0;
            padding: 0;
            list-style: none;

            & li {
                display: block;
                padding: 10px 10px 10px 0;
            }
            @media (min-width: 768px) {
                & li {
                    display: inline-block;
                    padding: 10px 10px 10px 0;
                }
            }            
        }
        }
      .social-connections { 
        display: flex;
        grid-area: 1 / 2 / 2 / 3; 
        & ul {
            margin-left: auto;
            margin-right: 0;
            padding: 0;
            list-style: none;

            & li {
                display: inline-block;
                padding: 10px 10px 10px 0;
            }

            & img {
                width: 16px;
            }
        }

      }


      .footer-band {
        margin-top: 2rem;
        border-top: 2px solid #fff;
      }

  `
];
USCampaignFooter = __decorate([
    customElement('us-campaign-footer')
], USCampaignFooter);
export { USCampaignFooter };
//# sourceMappingURL=us-campaign-footer.js.map